<template>
  <b-card>
    <monitoramento-list
      ref="monitoramentoList"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="true"
      :show-botao-custom="true"
      :esconderAcoes="true"
    >
      <template
        slot="custom-header"
        slot-scope="{ props} "
      >
        <div class="d-flex align-items-center justify-content-between">
          <span>{{ props.column.label }}</span>
          <b-button
            @click.stop="props.column.field === 'situacao' ? alternarSituacaoGeral() : visualizarGrupo(props.column.field) "
            variant="light"
            size="sm"
            class="ml-1 d-flex align-items-center justify-content-center"
          >
            <feather-icon :icon="colunasExpandidas[props.column.field] ? 'ChevronDownIcon' : 'ChevronRightIcon'" size="15" />
          </b-button>
        </div>
      </template>

      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <span
          v-if="props.row[props.column.field] === 'regular'"
        >
          <feather-icon
            icon="CheckCircleIcon"
            size="25"
            style="margin: 0 5px; color: #74B491;"
          />
        </span>
        <span
          v-else-if="props.row[props.column.field] === 'irregular'"
        >
          <feather-icon
            icon="XCircleIcon"
            size="25"
            style="margin: 0 5px; color: #EA5455;"
          />
      </span>
        <span
          v-else-if="props.row[props.column.field] === 'motivo'"
        >
          <feather-icon
            icon="MinusCircleIcon"
            size="25"
            style="margin: 0 5px; color: #283046;"
          />
        </span>
        <b-badge
          v-else
          variant="light-primary"
          class="badge-size-p"
        >
          -
          {{ props.row[props.column.field] }}

        </b-badge>
      </template>
    </monitoramento-list>
    <div
      ref="legenda"
    >
      <span class="text-nowrap item-legenda">
        Legenda:
        <feather-icon
          icon="CheckCircleIcon"
          size="25"
          style="margin: 0 5px; color: #74B491;"
        />
        <span class="text-nowrap">
          Regular
        </span>
      </span>

      <span class="text-nowrap item-legenda">
        <feather-icon
          icon="XCircleIcon"
          size="25"
          style="margin: 0 5px; color: #EA5455;"
        />
        Irregular
      </span>

      <span class="text-nowrap item-legenda">
        <feather-icon
          icon="MinusCircleIcon"
          size="25"
          style="margin: 0 5px; color: #283046;"
        />
        Motivo
      </span>

      <span class="text-nowrap item-legenda">
        <b-badge
          variant="light-primary"
          class="badge-size-p"
        >
          -
        </b-badge>
        Sem dados
      </span>
    </div>

    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="'Enviando'"
    />
  </b-card>
</template>

<style lang="scss">
.col-valores {
  white-space: nowrap;
}

[dir] #baixaPortalSelect .vs__dropdown-toggle {
  border-color: var(--primary) !important;
}

.item-legenda {
  margin: 5rem;
}
</style>

<script>
// import vSelect from 'vue-select'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from './shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'
import colunas from './shared/components/colunas'

export default {
  name: 'Monitoramento360View',
  components: {
    // vSelect,
    MonitoramentoList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    // VisualizarArquivo: () => import("@pilar/components/visualizar-arquivo/VisualizarArquivo.vue"),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    // Acoes: () => import("./shared/components/acoes/Acoes.vue"),
    // DownloadEmExcel: () => import("@app/download-excel/DownloadEmExcel.vue"),
  },

  data() {
    return {
      mostarArquivo: false,
      arquivo: '',
      empresaNome: '',
      botoesOption: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: CNPJ/CPF, Razão social',
        acaoClass: 'col-td-acao-2',
        disabledCheckbox: false,
        colunas: [],
      },
      filtros: [
        {
          colunas: [
            'CadastroFederalSemMascara',
            'CadastroFederal',
            'RazaoSocial',
          ],
          valor: null,
        },
      ],
      filtrosDefaultDocs: [],
      filtrosRapidosDocs: [],
      filtrosRapidos: [],
      filtroString: [],
      filtroAtual: {},
      isLoading: false,
      colunasExpandidas: {
        federal: false,
        certidoes: false,
        parcelamentos: false,
        simplesNacionalInfo: false,
      },
      expandindoSituacaoGeral: false,
    }
  },
  created() {
    this.visualizacao.colunas = JSON.parse(JSON.stringify(colunas))
    this.visualizacao.evento = this.carregar
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    resetarEstadoColunas() {
      this.expandindoSituacaoGeral = false
      Object.keys(this.colunasExpandidas).forEach(grupo => {
        this.colunasExpandidas[grupo] = false
      })
    },
    alternarSituacaoGeral() {
      this.expandindoSituacaoGeral = !this.expandindoSituacaoGeral

      this.visualizacao.colunas.forEach(col => {
        if (col.field === 'situacao') {
          // eslint-disable-next-line no-param-reassign
          col.visible = !this.expandindoSituacaoGeral
        } else if (['federal', 'certidoes', 'parcelamentos', 'simplesNacionalInfo'].includes(col.field)) {
          // eslint-disable-next-line no-param-reassign
          col.visible = this.expandindoSituacaoGeral
        } else if (col.grupo && !['federal', 'certidoes', 'parcelamentos', 'simplesNacionalInfo'].includes(col.field)) {
          // eslint-disable-next-line no-param-reassign
          col.visible = false
        }
      })
    },
    visualizarGrupo(grupo) {
      const expandido = this.colunasExpandidas[grupo]
      this.colunasExpandidas[grupo] = !expandido

      this.visualizacao.colunas.forEach(col => {
        if (col.grupo === grupo && col.thType !== 'custom-header') {
          // eslint-disable-next-line no-param-reassign
          col.visible = !expandido
        }
      })
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.monitoramentoList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.monitoramentoList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
      this.aplicarLegenda()
    },
    aplicarLegenda() {
      const interval = setInterval(() => {
        const totalPaginadoDiv = document.getElementById('TotalPagina')
        const spanElement = this.$refs.legenda
        totalPaginadoDiv.appendChild(spanElement)
        clearInterval(interval)
      }, 100)
    },
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return api.getPaginado(pagina, tamanhoPagina, filtro, this.filtroString)
    },
    executarFiltro() {
      this.$refs.relatorioConsumoList.montarGrid(this.$refs.relatorioConsumoList.enviarServidor)
    },
    visibleColunas() {
      this.visualizacao.colunas.forEach(coluna => {
        if (this.filtroString.length > 0 && !this.filtroString.includes('Todos')) {
          const filtroStringModificada = this.filtroString.map(s => s.replace(/[.\-\\/\s]/g, '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
          if (!filtroStringModificada.some(s => s.includes(coluna.field.replace('consumo', '').toLowerCase()))
            && this.arrayColunas.includes(coluna.field)) {
            // eslint-disable-next-line no-param-reassign
            coluna.visible = false
          } else {
            // eslint-disable-next-line no-param-reassign
            coluna.visible = true
          }
        } else {
          if (this.filtroString.length > 0) {
            this.filtroString = ['Todos']
          }
          // eslint-disable-next-line no-param-reassign
          coluna.visible = true
        }
      })
    },
  },
}
</script>
